<template>
  <span
    v-show="dataBadgeContent"
    class="absolute -bottom-0.5 -right-1/4 rounded-xl bg-black px-1 py-0.5 leading-none text-white"
    ><slot
  /></span>
</template>

<script lang="ts">
export default defineComponent({
  name: 'LinkBadge',
  props: {
    dataBadgeContent: {
      type: [Number, String, undefined] as PropType<
        number | string | undefined
      >,
      default: undefined,
    },
  },
})
</script>
